import useFetchPromise from './useFetchPromise';
import whitelistsApi from '../api/whitelistsApi';

const useFetchWalletsWhitelist = () =>
  useFetchPromise<[string, string][]>(whitelistsApi.fetchWalletsWhitelist, true);

export default useFetchWalletsWhitelist;
